import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { formatDateWithTime } from "../../../shared/utility";
import TextWithLabel from "../../controls/TextWithLabel";

export default function ProcessingHistoryDetails(props) {
  const { inProcessMonitoringHistory, setOpen } = props;

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              Processing History:{" "}
              <div> {inProcessMonitoringHistory?.[0]?.description_en} </div>
              <div> {inProcessMonitoringHistory?.[0]?.new_lot_number} </div>
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>

        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div className="flow-root">
            <ul className="-mb-8">
              {inProcessMonitoringHistory &&
              inProcessMonitoringHistory.length > 0 ? (
                inProcessMonitoringHistory.map((singleItem, eventIdx) => (
                  <li key={singleItem.id}>
                    <div className="relative pb-8">
                      {eventIdx !== inProcessMonitoringHistory.length - 1 ? (
                        <span
                          className="absolute left-2 top-4 -ml-px h-full w-0.5 bg-gray-200"
                          aria-hidden="true"
                        />
                      ) : null}
                      <div className="relative flex space-x-3">
                        <div>
                          <span className="flex h-4 w-4 items-center justify-center rounded-full ring-8 ring-white bg-gray-500"></span>
                        </div>
                        <div className="w-full">
                          <div className="grid grid-cols-3 gap-4">
                            <div className="col-span-2">
                              <TextWithLabel
                                label={`Status`}
                                text={singleItem.in_process_status_name}
                              />
                            </div>
                            <div>
                              <TextWithLabel
                                label="PLU"
                                text={singleItem.plu}
                              />
                            </div>
                          </div>

                          <div className="grid grid-cols-1 gap-4 mt-2">
                            <div className="col-span-2">
                              <TextWithLabel
                                label="Description"
                                text={singleItem.description_en}
                              />
                            </div>
                          </div>

                          <div className="grid grid-cols-2 gap-4 mt-2">
                            {/* <div>
                                <TextWithLabel
                                  label="Elapsed seconds"
                                  text={singleItem.elapsed_seconds}
                                />
                              </div> */}
                            <div>
                              <TextWithLabel
                                label="Process Started At"
                                text={formatDateWithTime(singleItem.created_at)}
                              />
                            </div>
                            <div>
                              <TextWithLabel
                                label="Employee"
                                text={singleItem.user_name}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))
              ) : (
                <li>
                  <div className="py-6 text-center text-sm text-gray-500">
                    No history found
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Close
        </button>
      </div>
    </div>
  );
}
